import { FC, HTMLAttributes } from 'react';
import Link from '@base/lib/ThemeLink';
import { useProductContext } from './useProductContext';
import cn from 'classnames';

export type IProductTitleProps = HTMLAttributes<HTMLHeadingElement>;

export const ProductTitle: FC<IProductTitleProps> = props => {
    const { product, link, title, canLinkJump } = useProductContext();
    const { className, ...rest } = props;
    return title === false ? null : (
        <div className={cn(className, 'g-title')} {...rest}>
            {(link === false || !canLinkJump)
                ? product.title
                : (
                    <Link href={product.url}>
                        <a className={'js-track-link'}>
                            {product.title}
                        </a>
                    </Link>
                )
            }
        </div>
    )
};